<div class="panel rs-bg-grey1">
  <div class="small-only-text-center">
    <div
      class="panel rs-inline-block rs-wd-s14 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
    ></div>
  </div>
  <div
    class="panel rs-maxw rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
  ></div>

  <div
    class="panel rs-maxw rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
  ></div>

  <div class="medium-text-right">
    <div
      class="panel rs-inline-block rs-wd-s17 rs-h-s3 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
    ></div>
  </div>
</div>
